/**
 * Configuración global de actions
 */
export const DO_ROUTE = "DO_ROUTE";
export const DO_IS_LOADING = "DO_IS_LOADING";
export const DO_REQUEST_API = "DO_REQUEST_API";
export const DO_LANDING = "DO_LANDING";
export const DO_LANDING_SUCCESS = "DO_LANDING_SUCCESS";
export const DO_LANDING_ERROR = "DO_LANDING_ERROR";
export const DO_PASO1_SUCCESS = "DO_PASO1_SUCCESS";
export const DO_PASO2_SUCCESS = "DO_PASO2_SUCCESS";
export const DO_PASO3_SUCCESS = "DO_PASO3_SUCCESS";
export const DO_PASO4_SUCCESS = "DO_PASO4_SUCCESS";
export const DO_PASO1_ERROR = "DO_PASO1_ERROR";
export const DO_PASO2_ERROR = "DO_PASO2_ERROR";
export const DO_PASO3_ERROR = "DO_PASO3_ERROR";
export const DO_PASO4_ERROR = "DO_PASO4_ERROR";
export const DO_PASO1 = "DO_PASO1";
export const DO_PASO2 = "DO_PASO2";
export const DO_PASO3 = "DO_PASO3";
export const DO_PASO4 = "DO_PASO4";
export const DO_GRACIAS = "DO_GRACIAS";
export const DO_MENSAJE = "DO_MENSAJE";
export const DO_NOTIFICATION_TOAST = "DO_NOTIFICATION_TOAST";
export const DO_NOTIFICATION_TOAST_RESET = "DO_NOTIFICATION_TOAST_RESET";
export const DO_TCODE = "DO_TCODE";
export const DO_TOKENIZE_USER = "DO_TOKENIZE_USER";
export const DO_TOKENIZE_USER_SUCCESS = "DO_TOKENIZE_USER_SUCCESS";
export const DO_TOKENIZE_USER_ERROR = "DO_TOKENIZE_USER_ERROR";
export const DO_LOAD_AEM_CAMPAIGNS = "DO_LOAD_AEM_CAMPAIGNS";
export const DO_LOAD_AEM_CAMPAIGNS_SUCCESS = "DO_LOAD_AEM_CAMPAIGNS_SUCCESS";
export const DO_LOAD_AEM_CAMPAIGNS_ERROR = "DO_LOAD_AEM_CAMPAIGNS_ERROR";
